module.exports = __webpack_public_path__ + "static/iCloud_5-0b379487f32e569002e1b696e26f994b.png";